import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ConsentListBody from "components/PatientManagement/Consent/ConsentListBody";

export default function Consent() {
  useEffect(() => {
    document.title = "Consent";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <ConsentListBody />
    </main>
  );
}
